import { useModalStatusMessage } from '@/hooks';
import ModalActions from '@components/modal/ModalActions';
import ModalContent from '@components/modal/ModalContent';
import ModalTitle from '@components/modal/ModalTitle';
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useMutation } from '@apollo/client';
import { Dialog, Typography } from '@mui/material';
import { FC } from 'react';
import RESTORE_USER from '../graphql/mutations/restoreUser';

interface Props {
  open: boolean;
  onClose: () => void;
  userId: number | null;
  userFullName?: string;
}

export const RestoreUserModal: FC<Props> = ({ userId, userFullName, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {userId != null && (
        <SuspenseComponent userId={userId} userFullName={userFullName} onClose={onClose} />
      )}
    </Dialog>
  );
};

const SuspenseComponent: FC<{ userId: number; userFullName?: string; onClose: () => void }> = ({
  userId,
  userFullName,
  onClose,
}) => {
  const { i18n } = useLingui();
  const { openModalSuccessMessage, openModalErrorMessage } = useModalStatusMessage();
  const [restoreUser, { loading }] = useMutation(RESTORE_USER, {
    variables: { input: { userId } },
    onCompleted: () => {
      openModalSuccessMessage(t(i18n)`Usuario desarchivado correctamente.`);
      onClose();
    },
    onError: (error) => {
      openModalErrorMessage(error.message);
    },
    refetchQueries: ['GetUsersGraveyard'],
  });

  return (
    <>
      <ModalTitle
        title={
          <Trans>
            Desarchivar usuario{userFullName && <> <strong>{userFullName}</strong></>}
          </Trans>
        }
      />
      <ModalContent>
        <Typography>
          <Trans>¿Estás seguro que deseas desarchivar este usuario?</Trans>
        </Typography>
      </ModalContent>
      <ModalActions
        onClose={onClose}
        submitButton={{
          label: t(i18n)`Desarchivar`,
          onClick: () => restoreUser(),
          loading,
        }}
      />
    </>
  );
};
